export default __webpack_public_path__ + "static/media/job_offer7_s.24d98c17.jpg";